module.exports = __webpack_public_path__ + "static/media/pic4.6ea0df94.jpg";